module.exports = __webpack_public_path__ + "img/icons8-peugeot.d57dd3a7.png";